import { useMutation } from "react-query";

import { uploadBulkLostCsv } from "../../../../../api/logistics/bulkLost";
import { notification } from "antd";

export const useUploadBulkLostCsv = () => {
  const {
    mutate: uploadCsv,
    isLoading: isUploading,
    isSuccess,
  } = useMutation(uploadBulkLostCsv, {
    onSuccess() {
      notification.success({
        message: "Upload Success",
        description: `The result will be sent to your email shortly`,
      });
    },
    onError(error) {
      notification.error({
        message: "Upload Error",
        description: `${error}`,
      });
    },
  });

  return { uploadCsv, isUploading, isSuccess };
};
